export const SOCIAL_LINKS = [
  { label: 'X', href: 'https://x.com/Illuminate_AI1', platform: 'x' },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/illuminatefaithai/',
    platform: 'instagram',
  },
  { label: 'TikTok', href: 'https://www.tiktok.com/@illuminatefaith', platform: 'tiktok' },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/channel/UCQkOWftsO6bIDbJigKZfDpw',
    platform: 'youtube',
  },
]
